<template>
  <div class="custom-icon">
    <el-tooltip
      :content="getTitle(type)"
      placement="top"
    >
      <i :class="getClass(type)" />
    </el-tooltip>
  </div>
</template>

<script>
import Vue from "vue";
import { Tooltip } from "element-ui";
import mapper from "./mapper.json";
import _get from "lodash.get";

Vue.use(Tooltip);

export default {
  props: {
    type: String,
    title: String
  },
  data() {
    return { mapper };
  },
  methods: {
    getClass(type) {
      return _get(mapper, type, {}).name;
    },
    getTitle(type) {
      return this.title
        ? this.title
        : _get(mapper, type, {}).title;
    }
  }
};
</script>

<style></style>
